import { useEffect, useRef } from "react";
import { CancelBookingEventDataFile } from "./data/CancelBookingEvent.Data";
import FormCreator from "../../../../components/forms/FormCreator";
import { useLazyGetAllDropDownForEventManagementQuery, useLazyGetCancellationReasonForCreditNoteQuery } from "../../../../app/services/EventManagement/EventManagementApi";
import { setAllDropDownFieldsBatch } from "../../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import Buttons from "../../../../components/ui/button/Buttons";
import SwalAlert from "../../../../services/swalService/SwalService";

const CancelBookingEvent = () => {
    const viewCancelBookingDataRef = useRef();
    const viewListDropDowns = [
        { dropdownName: "FinanceCancellationReason", fieldId: "cancellationReason" },
    ];
    const { confirm, success, error } = SwalAlert()
    const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();
    const [getCancellationReasonForCreditNote, { isLoading: getCancellationReasonForCreditNoteLoading, data: getCancellationReasonForCreditNoteData, isSuccess: getCancellationReasonForCreditNoteIsSuccess }] = useLazyGetCancellationReasonForCreditNoteQuery();


    // Effect for set dropdown
    useEffect(() => {
        if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
            // Updates dropdown fields in the form based on the fetched data
            setAllDropDownFieldsBatch(CancelBookingEventDataFile, viewListDropDowns, viewEventListDropDownData);
        }
    }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);
    useEffect(() => {
        if (!getCancellationReasonForCreditNoteLoading && getCancellationReasonForCreditNoteData && getCancellationReasonForCreditNoteIsSuccess) {
            if (getCancellationReasonForCreditNoteData.hasError === false) {
                success("Credit not Generated");
            }
            else {
                error("Not Generate Credit note")
            }
        }

    }, [getCancellationReasonForCreditNoteLoading, getCancellationReasonForCreditNoteIsSuccess, getCancellationReasonForCreditNoteData]);


    useEffect(() => {
        geEventListDropDown();
    }, []);

    const handleGenerateCreditNot = () => {
        getCancellationReasonForCreditNote();
    }

    return (<>
        <div className='row mt-4'>
            <FormCreator
                config={CancelBookingEventDataFile}
                ref={viewCancelBookingDataRef}
                key={false}
            />
            <div className="col-lg-6 btn-sec mt-2">
                <Buttons
                    onClick={handleGenerateCreditNot}
                    buttonText={"Generate"}
                    buttonTypeClassName="theme-btn btn mt-auto"
                    isLoading={false}
                />
            </div>
        </div>
    </>)
}
export default CancelBookingEvent